import React from 'react';
import { Button, Grid, Typography } from '@material-ui/core';

import { NewsSpreadsheetUploadResultModel } from '../../../Models/NewsSpreadsheetUploadResultModel';
import CustomAccordion from '../../../shared/components/CustomAccordion';
import { StatusResult } from '../../../shared/enum/StatusResult';
import { useResultStyles } from '../../../shared/components/UploadStyles';
import SucessImg from '../../../assets/sucess.svg';
import AlertImg from '../../../assets/alert.svg';
import ErrorImg from '../../../assets/error.svg';

interface IUploadResultProps {
    result: NewsSpreadsheetUploadResultModel,
    nameFile: string,
    onClickHistory: () => void,
    onClickNewUpload: () => void,
    onClickStartClassification: () => void
}

export function NewsSpreadsheetUploadResult({ result, nameFile, onClickHistory, onClickNewUpload, onClickStartClassification }: IUploadResultProps) {
    const classes = useResultStyles();

    function getTitle(): string {
        if (result.status == StatusResult.ERROR) {
            if (result.property == 'SpreadsheetAccess')
                return 'Não foi possível acessar a planilha inserida.';

            return 'Ocorreu um problema com o processamento da sua planilha.';
        } else {
            if (result.quantityInserted > 0)
                return 'Sua planilha foi processada com sucesso!';
            else
                return 'Nenhuma nova notícia foi importada.';
        }
    }

    function getSubTitle(): string {
        if (result.status == StatusResult.ERROR) {
            switch (result.property) {
            case 'SpreadsheetAccess':
                return 'Não foi possível abrir a planilha inserida para realizar o processamento de dados. Por gentiliza, revise a planilha e realize um novo upload.';
            case 'Repository':
                return 'Visite no seu histórico de planilhas e verifique se a planilha inserida se encontra na lista. Caso não a encontre, será necessário realizar um novo upload.';
            default:
                return 'Não conseguimos processar alguns campos da sua planilha. Por gentiliza, revise a planilha e realize um novo upload.';
            }
        } else {
            if (result.quantityInserted > 0) {
                if (result.quantityDuplicated > 0) {
                    if (result.quantityDuplicated == 1)
                        return `Foi encontrada ${result.quantityDuplicated.toString()} notícia já inserida anteriormente. Portanto foram importadas apenas ${result.quantityInserted.toString()} notícias das ${result.quantityTotal.toString()} processadas.`;

                    return `Foram encontradas ${result.quantityDuplicated.toString()} notícias já inseridas anteriormente. Portanto foram importadas apenas ${result.quantityInserted.toString()} notícias das ${result.quantityTotal.toString()} processadas.`;
                } else
                    return `Tudo pronto! Todas as ${result.quantityInserted.toString()} notícias foram importadas!`;
            }
            else
                return 'Todas as notícias processadas já estão inseridas nesta plataforma, portanto nenhuma notícia foi importada.';
        }
    }

    function getIcon() {
        if (result.status == StatusResult.ERROR) {
            return (
                <div className={classes.icon}>
                    <img src={ErrorImg} alt="" />
                </div>
            );
        } else {
            if (result.quantityInserted > 0)
                return (
                    <div className={classes.icon}>
                        <img src={SucessImg} alt="" />
                    </div>
                );
            else
                return (
                    <div className={classes.icon}>
                        <img src={AlertImg} alt="" />
                    </div>
                );
        }
    }

    return (
        <Grid
            container
            direction="column"
            justify="center"
            alignItems="center">
            <Typography variant="h4" className={classes.title}>
                {getTitle()}
            </Typography>
            <Typography variant="body1" className={classes.item}>
                {getSubTitle()}
            </Typography>
            {(result.quantityDuplicated > 0 && result.registeredMessage) && (
                <div className={classes.item}>
                    <CustomAccordion messages={result?.registeredMessage} title={'Noticias Já Cadastradas!'} />
                </div>
            )}
            {(result.status == StatusResult.ERROR) && (
                <div className={classes.item}>
                    <CustomAccordion messages={result.message} title={result.title} />
                </div>
            )}
            {getIcon()}
            <Typography variant="subtitle1" className={classes.nameFile}>
                {nameFile}
            </Typography>
            {result.quantityInserted > 0 && (
                <Button
                    size="large"
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={onClickStartClassification}>
                    INICIAR CLASSIFICAÇÃO
                </Button>
            )}
            {result.quantityInserted == 0 && (
                <Button
                    size="large"
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={onClickHistory}>
                    VERIFICAR HISTÓRICO DE PLANILHAS
                </Button>
            )}
            <Button
                size="large"
                variant="outlined"
                className={classes.button}
                onClick={onClickNewUpload}>
                FAZER UPLOAD DE NOVA PLANILHA
            </Button>
        </Grid>
    );
}